var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.allowShow)?_c('rate-select',{attrs:{"value":_vm.value,"summary":_vm.summary},on:{"valueChanged":_vm.onValueChanged},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_vm._v("\n\t\t"+_vm._s(_vm.$t("markHomeWork"))+"\n\t")]},proxy:true}],null,false,1378309041)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }